import React from "react";

function UniqueDaily (props) {

    return <p>{props.headerValue}: {props.totalUsers}</p>;
}

export default UniqueDaily;